module.exports = __webpack_public_path__ + "img/profile.5637d406.svg";